import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * usePageTitle — updates `document.title` on route changes.
 *
 * LEGACY: AngularJS `$stateChangeSuccess` handler set document.title
 * to "[Page Title] | APS Single Lookup" based on the current state.
 *
 * Uses prefix matching so nested routes (e.g., `/disputes/detail/123`)
 * match the parent route (`/disputes`). Default title is "APS Single Lookup".
 */

const APP_NAME = 'APS Single Lookup'

const PAGE_TITLES: Record<string, string> = {
    '/home': 'Home',
    '/dashboard': 'Dashboard',
    '/disputes': 'Dispute Cases',
    '/transactions': 'Transactions',
    '/arm-cases': 'ARM Cases',
    '/arm-alerts': 'ARM Alerts',
    '/comp-cards': 'Compromised Cards',
    '/csr-inquiries': 'Call Center',
    '/inquiries': 'Call Center',
    '/reviews': 'Reviews',
    '/dispute-trends': 'Dispute Trends',
    '/watchlistCases': 'Watchlist Cases',
    '/doc-management': 'Document Management',
    '/docmgmt': 'Document Management',
    '/analytics': 'Analytics',
    '/reporting': 'Reporting',
    '/branding': 'Branding',
    '/settings': 'Settings',
    '/sanction-list': 'Sanction List',
    '/lookup': 'Watchlist Search',
    '/batchArchive': 'Watchlist Batch Archive',
    '/bsaReview': 'BSA Reviews',
    '/irfReview': 'IRF Reviews',
    '/sarReviews': 'SAR Reviews',
    '/cleared-customers': 'Cleared Customers',
    '/authentication-settings': 'Authentication Settings',
}

/**
 * Sorted prefixes by length descending so longer prefixes match first
 * (e.g., `/arm-alerts` matches before `/arm`).
 */
const SORTED_PREFIXES = Object.keys(PAGE_TITLES).sort(
    (a, b) => b.length - a.length,
)

export function usePageTitle(): void {
    const location = useLocation()

    useEffect(() => {
        const pathname = location.pathname || '/'

        const matchedPrefix = SORTED_PREFIXES.find((prefix) =>
            pathname.startsWith(prefix),
        )

        if (matchedPrefix) {
            document.title = `${PAGE_TITLES[matchedPrefix]} | ${APP_NAME}`
        } else {
            document.title = APP_NAME
        }
    }, [location.pathname])
}
